import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators, FormControl } from '@angular/forms';
import { RegionData } from 'src/app/models/region.model';
import { PersonValueFormat } from 'src/app/models/PersonValueFormat.model';
import { TransportModeDefault } from 'src/app/models/TransportModeDefault';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-transport-defaults',
  templateUrl: './transport-defaults.component.html',
  styleUrls: ['./transport-defaults.component.scss']
})
export class TransportDefaultsComponent implements OnInit, OnDestroy {
  private formSubscription: Subscription | null = null;

  @Input('form') parentForm: FormGroup;
  @Input('data') data: RegionData;
  @Input('valueFormats') valueFormats: PersonValueFormat[];
  @Input('isEditable') isEditable: boolean;
  form: FormGroup;
  defaultsNames: string[] = [];
  get formData() { return <FormArray>this.form.get('defaults'); }

  constructor(private _formBuilder: FormBuilder) {
  }

  ngOnInit() {
    this.form = this.parentForm;
    // this.form = this._formBuilder.group({});
    this.form.addControl('name', new FormControl({ value: this.data.name, disabled: this.isEditable }));
    this.form.addControl('createdAtUtc', new FormControl(this.data.createdAtUtc));
    this.form.addControl('defaults', this._formBuilder.array([]));
    this.form.setControl('defaults', this.dataAsFormArray());

    this.subscribeToFormChanges();
  }

  dataAsFormArray(): FormArray {
    const fgs = this.data.defaults.map(o => this.asFormGroup(o));
    return new FormArray(fgs);
  }

  asFormGroup(o: TransportModeDefault): FormGroup {
    this.defaultsNames.push(o.transportModeName);
    const fg = new FormGroup({
      transportModeId: new FormControl(o.transportModeId),
      id: new FormControl(o.default.id),
      seatOccupancyRateDefault: new FormControl({ value: o.default.seatOccupancyRateDefault, disabled: this.isEditable }, Validators.required),
      standingOccupancyRateDefault: new FormControl({ value: o.default.standingOccupancyRateDefault, disabled: this.isEditable }, Validators.required),
      personsBoardingDefault: new FormControl({ value: o.default.personsBoardingDefault, disabled: this.isEditable }, Validators.required),
      personsDeboardingDefault: new FormControl({ value: o.default.personsDeboardingDefault, disabled: this.isEditable }, Validators.required),
      personValueFormatId: new FormControl({ value: o.default.personValueFormatId, disabled: this.isEditable }, Validators.required),
      personsPerSquareMeterEntranceArea: new FormControl({ value: o.default.personsPerSquareMeterEntranceArea, disabled: this.isEditable }, Validators.required),
      personsPerSquareMeterMultiPurposeArea: new FormControl({ value: o.default.personsPerSquareMeterMultiPurposeArea, disabled: this.isEditable }, Validators.required),
      personsPerSquareMeterAisle: new FormControl({ value: o.default.personsPerSquareMeterAisle, disabled: this.isEditable }, Validators.required)
    });
    return fg;
  }

  onKeyFunc(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    //             101 = e            69 = E            45 = -       
    if (charCode == 101 || charCode == 69 || charCode == 45) {
      return false;
    }
  }

  subscribeToFormChanges() {
    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
    }

    this.formSubscription = new Subscription();

    this.formData.controls.forEach((group: FormGroup) => {
      const sub = group.get('personValueFormatId')?.valueChanges.subscribe(value => {
        this.updateValidators(group, value);
      });
      if (sub) {
        this.formSubscription?.add(sub);
      }

      const initialValue = group.get('personValueFormatId')?.value;
      this.updateValidators(group, initialValue);
    });
  }

  updateValidators(group: FormGroup, formatId: number) {
    const boardingControl = group.get('personsBoardingDefault');
    const deboardingControl = group.get('personsDeboardingDefault');

    if (formatId === 1) {
      boardingControl?.setValidators([Validators.required, Validators.min(0), Validators.max(100)]);
      deboardingControl?.setValidators([Validators.required, Validators.min(0), Validators.max(100)]);
    } else {
      boardingControl?.setValidators([Validators.required, Validators.min(0)]);
      deboardingControl?.setValidators([Validators.required, Validators.min(0)]);
    }

    boardingControl?.updateValueAndValidity();
    deboardingControl?.updateValueAndValidity();
  }


  ngOnDestroy(): void {
    this.formSubscription?.unsubscribe();
  }
}
